import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import useLocalStorage from 'modules/core/lib/useLocalStorage'
import companies from 'modules/core/store/collections/companies'

import { companyInFreeTrial } from 'modules/billing/store/collections/subscriptions'

const useShowBecomeHint = () => {
  const [hideBecomeHint, setHideBecomeHint] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideBecomeHint
  )
  const currentCompany = companies.current

  const onCloseHint = () => {
    setHideBecomeHint(true)
  }

  return {
    shouldShowHint: !hideBecomeHint && companyInFreeTrial(currentCompany),
    onCloseHint,
  }
}

export default useShowBecomeHint
